module.exports = __webpack_public_path__ + "img/tallos_logo.7e013c7f.svg";